import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { DetailListExpandable } from '../detail-lists/detail-list-expandable';

export function GroupedListExpandable({items = []}) {
    return (
        <Box sx={{ bgcolor: 'none', p: 1 }}>
        <Stack spacing={2}>
            {items?.map((item) => (
                <DetailListExpandable headerItem={item} listItems={item.items || []} key={item.id}/>
            ))}
        </Stack>
        </Box>
    );
}
